import { render, staticRenderFns } from "./FilterPrice.vue?vue&type=template&id=1c02453e&"
import script from "./FilterPrice.vue?vue&type=script&lang=js&"
export * from "./FilterPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports